/**
 * Every Codebase management toggle except Agent Insights writes to a PR bot
 * installation row, so any of them can fail with a not-found error when the
 * repo has no installation. Recognising that error is what turns a dead-end
 * "couldn't update this setting" toast into the install flow, so the match
 * covers both wordings the backend returns.
 *
 * @param message error message from the toggle response
 * @returns true when the failure is a missing PR bot installation
 */
export function isMissingInstallationError(message: string): boolean {
  const msg = message.toLowerCase();
  return (
    msg.includes('pr bot installation not found') ||
    msg.includes('not found for repository')
  );
}
